import { Chip, Stack } from '@mui/material';
import { ReactElement } from 'react';

/** How often each value is mapped, in the order the values arrive. */
const countByValue = (values: string[]): [string, number][] => {
    const counts = new Map<string, number>();

    values.forEach(value => counts.set(value, (counts.get(value) ?? 0) + 1));

    return [...counts.entries()];
};

/**
 * The import values a unit, attribute or category is mapped from.
 *
 * All three mapping lists show this, and each built its own chip for it.
 *
 * Several mappings often carry the same wording — one category held twenty
 * chips of ten different words. Repeating them says nothing that the count
 * does not say shorter, so equal values are drawn once with how often they
 * occur.
 */
export const MappedValues = ({ values }: { values: string[] }): ReactElement =>
    0 === values.length ? (
        <>–</>
    ) : (
        <Stack direction="row" gap={0.5} flexWrap="wrap">
            {countByValue(values).map(([value, count]) => (
                <Chip key={value} size="small" label={count > 1 ? `${value} × ${count}` : value} />
            ))}
        </Stack>
    );
